<template>
    <div class="relative mt-1 mb-2">
        <div class="absolute inset-0 flex items-center pr-3" aria-hidden="true">
            <div class="w-full border-t border-cyan-50"/>
        </div>
        <div class="relative flex justify-start">
      <span class="pl-2 pr-3 text-md bg-cyan-700 font-medium text-cyan-50">
        {{ text }}
      </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "NavDivider",
    props: ['text']
}
</script>

<style scoped>

</style>
